import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount, decimals = 2) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(amount)
}

export function formatDate(dateStr) {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })
}

export function formatDateShort(dateStr) {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  })
}

export function getMonthYear(date = new Date()) {
  return date.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric'
  })
}

export function getCurrentDateString() {
  const now = new Date()
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
}

export function getStartOfMonth(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-01`
}

export function getEndOfMonth(date = new Date()) {
  const nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  return `${nextMonth.getFullYear()}-${String(nextMonth.getMonth() + 1).padStart(2, '0')}-${String(nextMonth.getDate()).padStart(2, '0')}`
}

export function getYearStart(year = new Date().getFullYear()) {
  return `${year}-01-01`
}

export function getYearEnd(year = new Date().getFullYear()) {
  return `${year}-12-31`
}

export function getQuarterStart(date = new Date()) {
  const quarter = Math.floor(date.getMonth() / 3)
  const startMonth = quarter * 3 + 1
  return `${date.getFullYear()}-${String(startMonth).padStart(2, '0')}-01`
}

export function getQuarterEnd(date = new Date()) {
  const quarter = Math.floor(date.getMonth() / 3)
  const endMonth = quarter * 3 + 3
  const lastDay = new Date(date.getFullYear(), endMonth, 0).getDate()
  return `${date.getFullYear()}-${String(endMonth).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`
}

// Convert file to base64
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      // Remove the data URL prefix to get just the base64 string
      const base64 = reader.result.split(',')[1]
      resolve(base64)
    }
    reader.onerror = error => reject(error)
  })
}

// Category icons mapping
export const categoryIcons = {
  fuel: 'Fuel',
  maintenance: 'Wrench',
  insurance: 'Shield',
  tolls: 'Road',
  permits: 'FileText',
  tires: 'Circle',
  truck_payment: 'Truck',
  trailer_payment: 'Container',
  lumper: 'Package',
  scale: 'Scale',
  parking: 'ParkingCircle',
  meals: 'Utensils',
  communication: 'Phone',
  eld: 'Monitor',
  factoring: 'Percent',
  dispatch: 'Headphones',
  office: 'Briefcase',
  other: 'MoreHorizontal'
}
